var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.90723 7H11.0928C11.273 6.99923 11.4489 6.94437 11.5983 6.84235C11.7477 6.74032 11.8638 6.59572 11.9321 6.42682C12.0004 6.25792 12.0176 6.07231 11.9818 5.89347C11.9459 5.71462 11.8584 5.55057 11.7305 5.42205L6.64685 0.272955C6.56215 0.186464 6.46139 0.117815 6.35037 0.0709672C6.23935 0.0241189 6.12027 0 6 0C5.87973 0 5.76065 0.0241189 5.64963 0.0709672C5.53861 0.117815 5.43785 0.186464 5.35315 0.272955L0.269496 5.42205C0.141564 5.55057 0.05413 5.71462 0.0182482 5.89347C-0.0176337 6.07231 -0.000351774 6.25792 0.0679092 6.42682C0.13617 6.59572 0.252344 6.74032 0.401742 6.84235C0.551139 6.94437 0.72705 6.99923 0.90723 7Z",
    fill: "#3747DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorUp);
export default __webpack_public_path__ + "static/media/VectorUp.c280ae3d1e0796c71c0ec4ecaf2a3e2a.svg";
export { ForwardRef as ReactComponent };